import { PlainExternalUserDto } from '@sib/api';
import type { Namespace } from '@sib/i18n';
import { UserAvatar } from '@sib/ui';
import { useDateFormat } from '@sib/utils';
import { format } from 'date-fns';
import { EntityActivityLogDescription } from './EntityActivityLogDescription';
import {
  EntityActivityLogActionKeys,
  EntityActivityLogDescription as EntityActivityLogDescriptionModel,
} from './entity-activity-log.types';

interface EntityActivityLogItemProps {
  itemKey: string;
  modifiedBy: PlainExternalUserDto | null;
  modifiedAt: string;
  descriptions: EntityActivityLogDescriptionModel[];
  actionKeys: EntityActivityLogActionKeys;
  ns: Namespace;
}

export const EntityActivityLogItem = ({
  itemKey,
  modifiedBy,
  modifiedAt,
  descriptions,
  actionKeys,
  ns,
}: EntityActivityLogItemProps) => {
  const dateFormat = useDateFormat();

  if (descriptions.length === 0) return null;

  return (
    <div className="border-border flex flex-col gap-1 border-b py-4">
      <div className="flex items-center gap-3">
        <UserAvatar
          variant="small"
          className="size-8 shrink-0"
          avatarImageProps={{ avatarUrl: modifiedBy?.avatarUrl }}
          avatarFallbackProps={{ name: modifiedBy?.name }}
        />
        <span className="text-primary min-w-0 truncate text-sm font-semibold">
          {modifiedBy?.name}
        </span>
        <span className="text-primary ml-auto shrink-0 text-sm">
          {format(modifiedAt, dateFormat.defaultDateTimeFormat)}
        </span>
      </div>
      <div className="text-muted-foreground flex flex-col gap-1 text-sm">
        {descriptions.map((description, index) => (
          <p key={`${itemKey}-description-${index}`}>
            <EntityActivityLogDescription
              description={description}
              actionKeys={actionKeys}
              ns={ns}
            />
          </p>
        ))}
      </div>
    </div>
  );
};
